import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problem() {
  return (
    <section className="problem_amj p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="solution_img">
              <StaticImage
                src="../../../images/case-studies/teemates/solution.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={611}
                height={606}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>Tekrevol’s Solution</h2>
            <p>
              We started the development phase of TeeMates Golf with a goal in
              mind: it had to be a success story – not only for us but for the
              overall golfing ecosystem that it would socialize.
            </p>
            <p>
              It had to be a user-friendly app, with a content-centric flow so
              golfers could share their stories in real time using different
              formats: simple texts, images and videos – as they love.
            </p>
            <p>
              Driving for success, we created an application that is super
              intuitive, allows personalizationand organization of Tee Times,
              has built-in eCommerce features where multiple buyers and sellers
              can create and maintain their trade profiles.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problem;
